import script from "./TravelerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelerModal.vue?vue&type=script&setup=true&lang=js"

import "./TravelerModal.vue?vue&type=style&index=0&id=f72822aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f72822aa"]])

export default __exports__